import connector from "@/repository/connector";

export default {
  async donationHistoryCsv(payload, options = {}) {
    return connector.requestWithFallback(
      () => connector.connector.post("donations/export_csv/", payload, options),
    );
  },
  async payoutsCsv(payload) {
    return connector.requestWithFallback(
      () =>
        connector.connector.post("payouts/export_csv/", payload, {
          responseType: "blob",
        }),
    );
  },
};
